import MostRecentOccurrence from "../MostRecentOccurrence";

export default function Insights({ attribute }) {
  return (
    <div className="u-p8 u-font12 u-text-gray-600">
      <MostRecentOccurrence da={attribute} />
    </div>
  );
}
